import $ from 'jquery'
import details from './details'
import is from '../is'
import user from '../user'
import index from '../project'

export const get = (project) => {
    let wait = $.Deferred()
    
    details.get(project).then(
        (r) => {
            if(!r.team.length)
                return wait.reject('Team details not found!').promise()
            
            let team = []
            
            $.each(r.team, (k, v) => {
                let bpInfo = r.bpDetails['BP'+v.bpNumber] || false
                
                if(bpInfo) {
                    let t = $.extend(true, {}, v)
                    t.bpInfo = bpInfo
                    team.push(t)
                }
            })
            
            let permissions = {}
            
            if(r.permissions) {
                if(r.permissions.team)
                    permissions = r.permissions.team
            }
            
            return wait.resolve({
                teams: team,
                permissions: permissions
            }).promise()
        },
        (err) => {
            return wait.reject(err).promise()
        }
    )
    
    return wait.promise()
}

const _action = (project, payload) => {
    let wait = $.Deferred()
    
    index.update(project, payload).then(
        (r) => {
            if(r.result.status !== 'success')
                return wait.reject(r.result.status).promise()
            
            details.get(project, 'team,bpDetails,permissions.team').then(
                (r) => {
                    return wait.resolve(r).promise()
                },
                (err) => {
                    return wait.reject(err).promise()
                }
            )
        },
        (err) => {
            return wait.reject(err).promise()
        }
    )
    
    return wait.promise()
}

export const add = (project, email, role) => {
    let wait = $.Deferred()
    
    _action(project, {
        request: [{
            action: 'team.add',
            resultKey: 'status',
            email: email,
            role: role
        }]
    }).then(
        (r) => {
            return wait.resolve(r).promise()
        },
        (err) => {
            return wait.reject(err).promise()
        }
    )
    
    return wait.promise()
}

export const activate = (project, bp) => {
    let wait = $.Deferred()
    
    _action(project, {
        request: [{
            action: 'team.activate',
            resultKey: 'status',
            bpNumber: bp
        }]
    }).then(
        (r) => {
            return wait.resolve(r).promise()
        },
        (err) => {
            return wait.reject(err).promise()
        }
    )
    
    return wait.promise()
}

export const deactivate = (project, bp) => {
    let wait = $.Deferred()
    
    _action(project, {
        request: [{
            action: 'team.deactivate',
            resultKey: 'status',
            bpNumber: bp
        }]
    }).then(
        (r) => {
            return wait.resolve(r).promise()
        },
        (err) => {
            return wait.reject(err).promise()
        }
    )
    
    return wait.promise()
}

export const update = (project, bp, role, auth) => {
    let wait = $.Deferred()
    
    _action(project, {
        request: [{
            action: 'team.update',
            resultKey: 'status',
            bpNumber: bp,
            role: role,
            auth: auth
        }]
    }).then(
        (r) => {
            return wait.resolve(r).promise()
        },
        (err) => {
            return wait.reject(err).promise()
        }
    )
    
    return wait.promise()
}

export const allowed = (what, permissions, team) => {
    let allowed = is.value(what, permissions)
    
    if(!$.isArray(allowed) || !allowed.length)
        return false
    
    if($.inArray(team.auth.split('.')[1], allowed) !== -1)
        return true
    
    if(team.bpNumber === user.getInfo().bpNumber)
        return $.inArray('self', allowed) !== -1
    
    return false
}

export const authLevels = (permissions, team, myAuthLevel) => {
    myAuthLevel = myAuthLevel.split('.')[1]
    let prefix = team.auth.split('.')[0]
    let allowed = permissions.update.auth
    
    let auths = {}
    
    if($.inArray('admin', allowed) !== -1 || myAuthLevel === 'admin')
        auths[prefix+'.admin'] = 'Administrator'
    
    if($.inArray('manager', allowed) !== -1 || myAuthLevel === 'manager')
        auths[prefix+'.manager'] = 'Manager'
    
    if($.inArray('member', allowed) !== -1 || myAuthLevel === 'member')
        auths[prefix+'.member'] = 'Member'
    
    return auths
}

export default {
    get, add,
    activate, deactivate,
    update, allowed, authLevels
}
